/* eslint-disable react/jsx-no-bind */
//@flow
import React, { useState } from 'react';
import { EnhancedInput } from 'common/components/core/input';
import NumberUtils from 'common/utils/NumberUtils';
import DataUtils from 'common/utils/DataUtils';
import { type ThemeType } from 'react-css-themr';

type Props = {
    onChange: number => void,
    defaultValue: number,
    rightIcon: string,
    min: number,
    theme: ThemeType
};

const EntityTransactionDurationInput = function (props: Props) {
    const { onChange, min, theme, rightIcon, defaultValue } = props;
    const [duration, setDuration] = useState(defaultValue);
    const onChangeHandler = function (value) {
        if (!NumberUtils.isNumeric(value) && !DataUtils.isEmpty(value)) {
            return;
        }
        setDuration(value);
        return onChange(value);
    };

    return (
        <EnhancedInput
            min={min}
            theme={theme}
            rightIcon={rightIcon}
            onChange={onChangeHandler}
            value={duration}
        />
    );
};

export default EntityTransactionDurationInput;
